const initialState = {
  isLoggedIn: false,
  userDetails: {},
  activeRoute: "0",
  userOptions: [],
  loading: { login: true }
};

const authAction = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_FAIL':
      return {
        ...state,
        // isLoggedIn: true,
        // userDetails: {
        //   ...action.payload
        // },
        loading: { ...state.loading, login: false }
      };
    case 'LOGIN':
      return {
        ...state,
        isLoggedIn: true,
        userDetails: {
          ...action.payload
        },
        loading: { ...state.loading, login: false }
      };

    case 'LOGOUT':
      return {
        ...state,
        isLoggedIn: false,
        userDetails: {}
      };
    default:
      return state;
  }
};

export default authAction;
